<template>
    <div id="pcm-dashboard-view">
        <div class="container-fluid">
            <!-- Page Heading -->
            <div class="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="h3 mb-0 text-gray-800">Tổng quan</h1>
            </div>

            <!-- Content Row -->
            <div class="row">

                <!-- Card Example -->
                <div class="col-xl-3 col-md-6 mb-4">
                    <div class="card border-left-primary shadow h-100 py-2" v-loading="loadingState.dashboard">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                    <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                        Số dự án tham gia
                                    </div>
                                    <div class="h5 mb-0 font-weight-bold text-gray-800">
                                        --
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <i class="fas fa-project-diagram fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card Example -->
                <div class="col-xl-3 col-md-6 mb-4">
                    <div class="card border-left-info shadow h-100 py-2" v-loading="loadingState.dashboard">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                    <div class="text-xs font-weight-bold text-info text-uppercase mb-1">
                                        Số vấn đề tồn tại
                                    </div>
                                    <div class="h5 mb-0 font-weight-bold text-gray-800">
                                        --
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <i class="fas fa-clipboard-list fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card Example -->
                <div class="col-xl-3 col-md-6 mb-4">
                    <div class="card border-left-warning shadow h-100 py-2" v-loading="loadingState.dashboard">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                    <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                        Giờ làm thêm
                                    </div>
                                    <div class="h5 mb-0 font-weight-bold text-gray-800">--</div>
                                </div>
                                <div class="col-auto">
                                    <i class="fas fa-clock fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card Example -->
                <div class="col-xl-3 col-md-6 mb-4">
                    <div class="card border-left-success shadow h-100 py-2 cursor-pointer" v-loading="loadingState.dashboard" @click="$router.push({name: 'attendance'})">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                    <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                                        Ngày đi làm thực tế
                                    </div>
                                    <div class="h5 mb-0 font-weight-bold text-gray-800">
                                        {{dashboard.work_day}}
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <i class="fas fa-business-time fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Content Row -->
            <div class="row">

                <!-- Area Chart -->
                <div class="col-xl-8 col-lg-7">
                    <div class="card shadow mb-4" v-loading="loadingState.attendance">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Chấm công</h6>
                            <div class="dropdown no-arrow">
                                <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                    aria-labelledby="dropdownMenuLink">
                                    <div class="dropdown-header">Tùy chọn</div>
                                    <button class="dropdown-item" @click="dialogVisible.attendance = true">Gửi yêu cầu</button>
                                </div>
                            </div>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body text-center" style="padding: 3rem">
                            <h6>{{currentDateTime.format('ddd, DD/MM/YYYY')}}</h6>
                            <h1 class="text-gray-900">{{currentDateTime.format('HH:mm:ss')}}</h1>
                            <div class="attendances">
                                <button v-if="!buttonState.btnCheckIn.checked" class="btn btn-icon-split" 
                                    :class="buttonState.btnCheckIn.class"
                                    :disabled="buttonState.btnCheckIn.disabled"
                                    @click="checkIn"
                                >
                                    <span class="icon text-white-50">
                                    <i class="fas fa-check"></i>
                                    </span>
                                    <span class="text">Check In</span>
                                </button>
                                
                                <button v-if="buttonState.btnCheckIn.checked" class="btn btn-icon-split"
                                    :class="buttonState.btnCheckOut.class" 
                                    :disabled="buttonState.btnCheckOut.disabled"
                                    @click="checkOut"
                                >
                                    <span class="icon text-white-50">
                                    <i class="fas fa-check"></i>
                                    </span>
                                    <span class="text">Check Out</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card shadow mb-4">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Dự án</h6>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body text-center">
                            
                        </div>
                    </div>
                </div>

                <!-- Pie Chart -->
                <div class="col-xl-4 col-lg-5">
                    <div class="card shadow mb-4">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Thông báo</h6>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body">
                            
                        </div>
                    </div>

                    <div class="card shadow mb-4">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Vấn đề tồn tại</h6>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body">
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- /.container-fluid -->

        <!-- Attendance Reuest Component -->
        <att-request :dialog-visible="dialogVisible.attendance" @closeDialog="dialogVisible.attendance = false" @success="successAttendanceRequest" />
        
    </div>
</template>

<script>
    import moment from 'moment'
    import _ from 'lodash'
    import {
        mapGetters
    } from 'vuex'

    //API
    import API_ATTENDANCE from '@/utils/api/attendance'
    import API_USER from '@/utils/api/user'

    //Component
    export default {
        name: 'pcm-dashboard-view',
        data() {
            return {
                loadingState: {
                    attendance: false,
                    dashboard: false
                },
                currentDateTime: moment(),
                buttonState: {
                    btnCheckIn: {
                        class: 'btn-success',
                        disabled: true,
                        checked: false
                    },
                    btnCheckOut: {
                        class: 'btn-info',
                        disabled: false
                    }
                },
                dialogVisible: {
                    attendance: false
                },
                dashboard: {
                    work_day: 0
                }
            }
        },
        components: {
            'att-request': () => import('@/components/attendance/Request.vue')
        },
        computed: {
            ...mapGetters([
                'getSettings'
            ]),
            _() {
                return _
            }
        },
        created() {
            let self = this
            this.$emit('activeMenu', 'dashboard')
            this.initAttendance()
            setInterval(function() {
                self.currentDateTime = moment()
                if (self.currentDateTime.format('HH:mm:ss') == '00:00:00') {
                    self.buttonState.btnCheckIn.disabled = true
                    self.buttonState.btnCheckIn.checked = false
                }
                self.updateAttendance()
            }, 1000);
            this.loadDashboard()
        },
        methods: {
            loadDashboard(){
                let self = this
                self.loadingState.dashboard = true
                API_USER.getMyDashboard(self.$axios, {}, (data) => {
                    self.loadingState.dashboard = false
                    if (data.status) {
                        self.dashboard = data.data
                    }
                }, (error) => {
                    self.loadingState.dashboard = false
                })
            },
            updateAttendance() {
                let WORKING_START   = _.find(this.getSettings.data, {'setting_key': 'WORKING_START_TIME'})
                let CHECK_IN_BEFORE = _.find(this.getSettings.data, {'setting_key': 'CHECK_IN_BEFORE'})
                let CHECK_IN_AFTER  = _.find(this.getSettings.data, {'setting_key': 'CHECK_IN_AFTER'})
                if (WORKING_START && CHECK_IN_BEFORE && CHECK_IN_AFTER) {
                    //CHECKIN
                    if (!this.buttonState.btnCheckIn.checked) {
                        let startCheckIn   = moment({hour: WORKING_START.setting_value.split(':')[0], minute: WORKING_START.setting_value.split(':')[1]}).subtract(CHECK_IN_BEFORE.setting_value, 'minutes')
                        let warningCheckIn = moment({hour: WORKING_START.setting_value.split(':')[0], minute: WORKING_START.setting_value.split(':')[1]})
                        let dangerCheckIn = moment({hour: WORKING_START.setting_value.split(':')[0], minute: WORKING_START.setting_value.split(':')[1]}).add(CHECK_IN_AFTER.setting_value, 'minutes')
                        if (this.currentDateTime >= startCheckIn) {
                            this.buttonState.btnCheckIn.disabled = false
                            if (this.currentDateTime >= warningCheckIn && this.currentDateTime <= dangerCheckIn) {
                                this.buttonState.btnCheckIn.class = 'btn-warning'
                            } else if (this.currentDateTime > dangerCheckIn) {
                                this.buttonState.btnCheckIn.class = 'btn-danger'
                            } else {
                                this.buttonState.btnCheckIn.class = 'btn-success'
                            }
                        }
                    }
                }
            },
            initAttendance() {
                let self = this
                self.loadingState.attendance = true
                API_ATTENDANCE.getState(self.$axios, function(data) {
                    self.loadingState.attendance = false
                    if (data.status) {
                        self.buttonState.btnCheckIn.checked = data.data.btnCheckIn.checked
                        self.buttonState.btnCheckOut.disabled = data.data.btnCheckOut.disabled
                    }
                }, function(error) {

                })
            },
            checkIn() {
                let self   = this
                if (self.buttonState.btnCheckIn.class == 'btn-danger') {
                    self.$prompt('Nhập lý do đến muộn', 'Cảnh báo !!!', {
                        customClass: 'el-promt-error',
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        inputValidator: function(val) {
                            if (!val || val.trim() == '') {
                                return 'Bắt buộc nhập'
                            }
                            return true
                        }
                    }).then(({value}) => {
                        self.loadingState.attendance = true
                        let form = {
                            reason_late: value
                        }
                        API_ATTENDANCE.checkIn(self.$axios, form, function(data) {
                            self.loadingState.attendance = false
                            if (data.status) {
                                self.showMessage('success', 'Thành công')
                                self.buttonState.btnCheckIn.checked = true
                            } else {
                                self.showMessage('error', data.error_message)
                            }
                        }, function(error) {
                            self.loadingState.attendance = false
                        }) 
                    }).catch(() => {
                        return
                    })
                } else {
                    self.loadingState.attendance = true
                    let form = {}
                    API_ATTENDANCE.checkIn(self.$axios, form, function(data) {
                        self.loadingState.attendance = false
                        if (data.status) {
                            self.showMessage('success', 'Thành công')
                            self.buttonState.btnCheckIn.checked = true
                        } else {
                            self.showMessage('error', data.error_message)
                        }
                    }, function(error) {
                        self.loadingState.attendance = false
                    }) 
                }
            },
            checkOut() {
                let self          = this
                let WORKING_END   = _.find(this.getSettings.data, {'setting_key': 'WORKING_END_TIME'})
                let startCheckOut = moment({hour: WORKING_END.setting_value.split(': ')[0], minute: WORKING_END.setting_value.split(':')[1]})
                if (self.currentDateTime < startCheckOut) {
                    self.$prompt('Nhập lý do về sớm', 'Cảnh báo !!!', {
                        customClass: 'el-promt-error',
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        inputValidator: function(val) {
                            if (!val || val.trim() == '') {
                                return 'Bắt buộc nhập'
                            }
                            return true
                        }
                    }).then(({value}) => {
                        self.loadingState.attendance = true
                        let form = {
                            reason_soon: value
                        }
                        API_ATTENDANCE.checkOut(self.$axios, form, function(data) {
                            self.loadingState.attendance = false
                            if (data.status) {
                                self.showMessage('success', 'Thành công')
                                self.buttonState.btnCheckOut.disabled = true
                                self.dashboard.work_day = data.data.work_day
                            } else {
                                self.showMessage('error', data.error_message)
                            }
                        }, function(error) {
                            self.loadingState.attendance = false
                        }) 
                    }).catch(() => {
                        return
                    })
                } else {
                    self.loadingState.attendance = true
                    let form = {}
                    API_ATTENDANCE.checkOut(self.$axios, form, function(data) {
                        self.loadingState.attendance = false
                        if (data.status) {
                            self.showMessage('success', 'Thành công')
                            self.buttonState.btnCheckOut.disabled = true
                            self.dashboard.work_day = data.data.work_day
                        } else {
                            self.showMessage('error', data.error_message)
                        }
                    }, function(error) {
                        self.loadingState.attendance = false
                    }) 
                }
            },
            successAttendanceRequest(data) {
                this.buttonState.btnCheckIn.checked = data.data.btnCheckIn.checked
                this.buttonState.btnCheckOut.disabled = data.data.btnCheckOut.disabled
                this.dialogVisible.attendance = false
            }
        }
    }
</script>